import { ElementRef, Input, OnChanges, OnInit, SimpleChanges, Directive } from '@angular/core';
import { hideElementVisibility, showElementVisibility } from './toggle-element-visibility';

@Directive()
export abstract class VisibilityToggler<T> implements OnInit, OnChanges {
  @Input() miqShowFavoriteOptions: { showFavorites: boolean; favorites: { [key: number]: boolean } };
  input: T;

  constructor(protected el: ElementRef) {}
  ngOnChanges({ miqShowFavoriteOptions }: SimpleChanges): void {
    if (miqShowFavoriteOptions && !miqShowFavoriteOptions.firstChange) {
      this.evalVisibility();
    }
  }
  ngOnInit(): void {
    this.evalVisibility();
  }

  abstract shouldHide(favorites: { [key: number]: boolean }): boolean;

  protected evalVisibility() {
    const { showFavorites, favorites } = this.miqShowFavoriteOptions;
    return showFavorites && this.shouldHide(favorites) ? this.hide() : this.show();
  }

  protected hide() {
    hideElementVisibility(this.el);
  }

  protected show() {
    if (this.el.nativeElement.style.visibility) {
      showElementVisibility(this.el);
    }
  }
}
